import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });

api.interceptors.request.use(cfg => {
  const stored = localStorage.getItem('bp_user');
  if (stored) cfg.headers.Authorization = `Bearer ${JSON.parse(stored).token}`;
  return cfg;
});

// Auth
export const loginApi    = (email, password) => api.post('/auth/login', { email, password });
export const registerApi = (name, email, password) => api.post('/auth/register', { name, email, password });
export const getMeApi    = () => api.get('/auth/me');

// Books
export const getBooksApi  = (params) => api.get('/books', { params });
export const getBookApi   = (id) => api.get(`/books/${id}`);
export const readChapterApi = (bookId, chId) => api.get(`/books/${bookId}/chapters/${chId}`);

// Chapters
export const likeChapterApi = (chId) => api.post(`/chapters/${chId}/like`);

// Comments
export const getCommentsApi  = (chapterId, params) => api.get(`/comments/chapter/${chapterId}`, { params });
export const postCommentApi  = (data) => api.post('/comments', data);
export const likeCommentApi  = (id) => api.post(`/comments/${id}/like`);
export const deleteCommentApi = (id) => api.delete(`/comments/${id}`);

// Payments
export const createOrderApi   = (itemId, itemType) => api.post('/payments/create-order', { itemId, itemType });
export const verifyPaymentApi = (data) => api.post('/payments/verify', data);
export const mockPayApi       = (itemId, itemType) => api.post('/payments/mock-complete', { itemId, itemType });
export const getPurchasesApi  = () => api.get('/payments/history');

// Admin
export const getAdminStatsApi   = () => api.get('/admin/stats');
export const getAdminBooksApi   = () => api.get('/admin/books');
export const createBookApi      = (fd) => api.post('/admin/books', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateBookApi      = (id, fd) => api.put(`/admin/books/${id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteBookApi      = (id) => api.delete(`/admin/books/${id}`);
export const addChapterApi      = (bookId, data) => api.post(`/admin/books/${bookId}/chapters`, data);
export const updateChapterApi   = (id, data) => api.put(`/admin/chapters/${id}`, data);
export const deleteChapterApi   = (id) => api.delete(`/admin/chapters/${id}`);
export const getAdminUsersApi   = () => api.get('/admin/users');

export default api;
